import { Component } from "@angular/core";
import { SharedModule } from "@app/shared/shared.module";

@Component({
    selector: "document-templates-mail-merge-info",
    templateUrl: "./document-templates-mail-merge-info.component.html",
    styleUrls: ["./document-templates-mail-merge-info.component.scss"],
    imports: [SharedModule]
})
export class DocumentTemplatesMailMergeInfoComponent {}
